<template>
  <v-app class="secondary">
    <Alert />
    <Dialog v-if="isLogin && showRemind" />
    <Navigation />
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Alert from "./components/Alert";
import Dialog from "./components/Dialog";
import Navigation from "./components/Navigation";

export default {
  name: "App",
  components: {
    Alert,
    Dialog,
    Navigation,
  },
  async created() {
    try {
      // 先載入學期資訊
      await this.$store.dispatch("getAllSemesters");

      // 檢查登入狀態（若未登入會自動跳轉 SSO）
      await this.$store.dispatch("isLogin");
    } catch (err) {
      console.error("[App 初始化錯誤]", err);
    }
    
  },
  computed: {
    showRemind() {
      return this.$store.state.showRemind;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
};
</script>
